// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__fjiA9","productName":"Table_productName__1CZRB"};